import { render, staticRenderFns } from "./SSelectAreaAllow.vue?vue&type=template&id=3f757d64"
import script from "./SSelectAreaAllow.vue?vue&type=script&lang=js"
export * from "./SSelectAreaAllow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports